import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const markSeen = createAsyncThunk(
  "markSeen/markSeenNotification",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post(
        `notification/mark-seen/${payload._id}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const markSeenSlice = createSlice({
  name: "markSeen",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(markSeen.pending, (state) => {
        state.loading = true;
      })
      .addCase(markSeen.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(markSeen.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default markSeenSlice.reducer;
